// Запрос к помощнику. Мутация, а не запрос-с-кэшем: вопрос — это действие человека, и
// повторный ответ на тот же вопрос обязан быть свежим. Кэш здесь означал бы вчерашние деньги
// под сегодняшним вопросом.

import { useMutation, useQuery } from '@tanstack/react-query';
import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query';

import type { AssistantAnswer, AssistantQuery } from '@/shared/api/endpoints/assistant';
import { ask, fetchAssistantQueries } from '@/shared/api/endpoints/assistant';
import type { ListResponse } from '@/shared/api/types';
import type { ApiError } from '@/shared/errors/api-error';

/** Что уходит на сервер: сам вопрос и прошлые вопросы этого же человека, свежий первым. */
export interface Спрос {
  question: string;
  history: string[];
}

export function useAsk(): UseMutationResult<AssistantAnswer, ApiError, Спрос> {
  return useMutation<AssistantAnswer, ApiError, Спрос>({
    // МОЛЧИТ намеренно: ответ помощника и есть подтверждение, и он подробнее любого «готово».
    // Всплывающее окно поверх ответа заслонило бы то, ради чего спрашивали.
    mutationFn: ({ question, history }) => ask(question, history),
  });
}

/**
 * О чём МОЖНО спросить — по правам этого человека.
 *
 * Список приходит с сервера и зависит от прав: у охранника он короче, чем у финдиректора. До
 * 26.08.2026 окно помощника предлагало три фразы, зашитые в веб, — одни и те же всем, включая
 * тех, кому такой ответ не положен. Дверь при этом была и считала список правильно.
 *
 * Кэшируется надолго: состав вопросов меняется вместе с правами, а не в течение сессии.
 */
export function useAssistantQueries(
  enabled = true,
): UseQueryResult<ListResponse<AssistantQuery>, ApiError> {
  return useQuery<ListResponse<AssistantQuery>, ApiError>({
    queryKey: ['assistant', 'queries'],
    queryFn: () => fetchAssistantQueries(),
    staleTime: 10 * 60 * 1000,
    enabled,
  });
}
